// TODO rename file to jsx file and move into components->globalComponents
// eslint-disable-next-line max-classes-per-file
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function createLinkContent(item) {
  const submenuIcon = item.items && (
    <i className="material-icons layout-submenu-toggler">
      keyboard_arrow_down
    </i>
  );
  const badge = item.badge && (
    <span className="menuitem-badge">{item.badge}</span>
  );
  return (
    <>
      <i className="material-icons">{item.icon}</i>
      <span className="menuitem-text">{item.label}</span>
      {submenuIcon}
      {badge}
    </>
  );
}

class AppSubmenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // TODO is method necessary?
  componentDidUpdate(prevProps /* prevState, snapshot */) { // TODO code parameters here necessary?
    const { menuActive } = this.props;
    if (this.isHorizontal() && prevProps.menuActive && !menuActive) {
      this.setState({ activeIndex: null });
    }
  }

  onMenuItemClick(event, item, index) {
    // avoid processing disabled items
    if (item.disabled) {
      event.preventDefault();
      return; /* true */ // TODO code necessary?
    }
    const { onRootItemClick, root } = this.props;
    if (root && onRootItemClick) {
      onRootItemClick({
        originalEvent: event,
        item,
      });
    }

    const { onMenuItemClick } = this.props;
    if (onMenuItemClick) {
      onMenuItemClick({
        originalEvent: event,
        item,
      });
    }

    // execute command
    if (item.command) {
      item.command({ originalEvent: event, item });
    }

    const { activeIndex } = this.state;
    const { items } = this.props;
    if (index === activeIndex) {
      const hasChildren = items[activeIndex].items
        && items[activeIndex].items.length > 0;
      this.setState({ activeIndex: hasChildren ? null : index });
    } else {
      this.setState({ activeIndex: index });
    }
  }

  onMenuItemMouseEnter(index) {
    const { root, menuActive } = this.props;
    if (root && menuActive && this.isHorizontal()) {
      this.setState({ activeIndex: index });
    }
  }

  // todo: check if method is still necessary!
  static getDerivedStateFromProps(nextProps /* prevState */) {
    if (nextProps.parentMenuItemActive === false) {
      return {
        activeIndex: null,
      };
    }
    return null;
  }

  // todo: check if method is still necessary!
  isHorizontal() {
    const { layoutMode } = this.props;
    return layoutMode === 'horizontal';
  }

  renderLink(item, i) {
    const content = createLinkContent(item);

    if (item.to) {
      return (
        <NavLink
          id={item.to.substring(1, item.to.length)}
          activeClassName="active-menuitem-routerlink"
          to={item.to}
          onClick={(e) => this.onMenuItemClick(e, item, i)}
          exact
          target={item.target}
          onMouseEnter={() => this.onMenuItemMouseEnter(i)}
          className={item.styleClass}
        >
          {content}
        </NavLink>
      );
    }
    return (
      <a
        className={classNames('ripplelink', item.styleClass)}
        href={item.url}
        onClick={(e) => this.onMenuItemClick(e, item, i)}
        target={item.target}
        onMouseEnter={() => this.onMenuItemMouseEnter(i)}
      >
        {content}
      </a>
    );
  }

  render() {
    const {
      onMenuItemClick, layoutMode, menuActive, className,
    } = this.props;
    let { items } = this.props;
    const { activeIndex } = this.state;
    items = items && items.map((item, i) => {
      const active = activeIndex === i;
      const styleClass = classNames(item.badgeStyleClass, {
        'active-menuitem': active,
      });

      return (
        <li className={styleClass} key={`menu_item_${item.label}`}>
          {this.renderLink(item, i)}
          <AppSubmenu
            items={item.items}
            onMenuItemClick={onMenuItemClick}
            layoutMode={layoutMode}
            menuActive={menuActive}
            parentMenuItemActive={active}
          />
        </li>
      );
    });

    return <ul className={className}>{items}</ul>;
  }
}

AppSubmenu.defaultProps = {
  className: null,
  items: null,
  onRootItemClick: null,
  onMenuItemClick: null,
  root: false,
  layoutMode: null,
  menuActive: false,
  parentMenuItemActive: false,
};

AppSubmenu.propTypes = {
  className: PropTypes.string,
  items: PropTypes.instanceOf(Array),
  onRootItemClick: PropTypes.func,
  onMenuItemClick: PropTypes.func,
  root: PropTypes.bool,
  layoutMode: PropTypes.string,
  menuActive: PropTypes.bool,
  parentMenuItemActive: PropTypes.bool,
};

export default class AppMenu extends Component {
  render() {
    const {
      model, active, onMenuItemClick, onRootMenuItemClick, layoutMode,
    } = this.props;
    return (
      <AppSubmenu
        items={model}
        className="layout-menu"
        menuActive={active}
        onMenuItemClick={onMenuItemClick}
        onRootItemClick={onRootMenuItemClick}
        root
        layoutMode={layoutMode}
        parentMenuItemActive
      />
    );
  }
}

AppMenu.defaultProps = {
  model: null,
  onRootMenuItemClick: null,
  onMenuItemClick: null,
  layoutMode: null,
  active: false,
};

AppMenu.propTypes = {
  model: PropTypes.instanceOf(Array),
  layoutMode: PropTypes.string,
  onRootMenuItemClick: PropTypes.func,
  onMenuItemClick: PropTypes.func,
  active: PropTypes.bool,
};
